const STATS = [
  { value: '99.9%', label: 'Uptime Guarantee' },
  { value: '< 15 min', label: 'Avg Response Time' },
  { value: '100+', label: 'Businesses Served' },
  { value: '24/7', label: 'Support Available' },
];

export function StatsBar() {
  return (
    <section className="py-14 bg-slate-50 border-y border-slate-200" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {STATS.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-black text-blue-600 mb-1" style={{ fontFamily: 'Chivo, sans-serif' }}>
                {stat.value}
              </div>
              <div className="text-sm text-slate-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
